(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aaa-recommendations"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aaa-recommendations')) {
  customElements.define('aaa-recommendations', class extends HTMLElement {
    async connectedCallback() {
      if(this.loaded) return;
      this.loaded=true;
      const normalize=value=>(value||'').trim().toLowerCase();
      const gender=data=>{const value=normalize(data.gender);const title=normalize(data.title);if(value.includes('unisex')||title.includes('unisex'))return 'unisex';if(value.includes('women')||title.includes('for women'))return 'women';if(value==='men'||title.includes('for men'))return 'men';return '';};
      const notes=value=>[...new Set((value||'').split('|').map(normalize).filter(Boolean))];
      const sourceNotes=notes(this.dataset.notes), sourceGender=gender(this.dataset);
      const excluded=new Set(this.dataset.exclude.split(','));
      let candidates=[...this.querySelectorAll('template[data-aaa-candidate]')];
      const render=()=>{
        const unique=new Map();
        candidates.forEach((node,index)=>{
          const d=node.dataset,g=gender(d);
          if(excluded.has(d.id)||d.key===this.dataset.key)return;
          if(sourceGender&&sourceGender!=='unisex'&&g&&g!=='unisex'&&g!==sourceGender)return;
          const shared=notes(d.notes).filter(note=>sourceNotes.includes(note));
          const ratio=Math.max(Number(d.price),1)/Math.max(Number(this.dataset.price),1);
          const score=shared.length*100+(g===sourceGender&&g?8:0)+(normalize(d.type)===normalize(this.dataset.type)&&d.type?3:0)-Math.abs(Math.log(ratio))*5-index/1000;
          const entry={node,shared,score,price:Number(d.price)};
          const prior=unique.get(d.key);
          if(!prior||entry.price<prior.price)unique.set(d.key,entry);
        });
        const entries=[...unique.values()].sort((a,b)=>b.score-a.score).slice(0,4);
        const grid=this.querySelector('[data-recommendation-grid]');grid.replaceChildren();
        entries.forEach(({node,shared})=>{const item=document.createElement('div');item.className='aaa-recommendation-item';item.append(node.content.cloneNode(true));if(shared.length){const p=document.createElement('p');p.className='aaa-match-reason';p.textContent=this.dataset.label+' '+shared.slice(0,3).join(', ');item.append(p);}grid.append(item);});
        this.hidden=!entries.length;
      };
      render();
      if(sourceNotes.length){
        const url=new URL(this.dataset.search,location.origin);
        url.searchParams.set('q',sourceNotes.slice(0,3).map(note=>'"'+note.replaceAll('"','')+'"').join(' OR '));
        url.searchParams.set('type','product');url.searchParams.set('section_id','aaa-recommendation-search');
        fetch(url).then(response=>response.ok?response.text():'').then(text=>{const html=new DOMParser().parseFromString(text,'text/html');candidates.push(...html.querySelectorAll('template[data-aaa-candidate]'));render();}).catch(()=>{});
      }
      try {const response=await fetch(this.dataset.url);if(!response.ok)return;const html=new DOMParser().parseFromString(await response.text(),'text/html');candidates=[...html.querySelectorAll('template[data-aaa-candidate]'),...candidates];render();}catch(error){}
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
